import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';
export function cn(...inputs) { return twMerge(clsx(inputs)); }

// Auto-inject theme CSS variable defaults (overridden by theme.css when present)
if (typeof window !== 'undefined' && !document.getElementById('__thm')) {
  const s = document.createElement('style');
  s.id = '__thm';
  s.textContent = ':root{--primary:239 84% 67%;--primary-foreground:0 0% 100%;--background:0 0% 100%;--foreground:222.2 84% 4.9%;--card:0 0% 100%;--card-foreground:222.2 84% 4.9%;--secondary:210 40% 96.1%;--secondary-foreground:222.2 47.4% 11.2%;--muted:210 40% 96.1%;--muted-foreground:215.4 16.3% 46.9%;--accent:210 40% 96.1%;--border:214.3 31.8% 91.4%;--input:214.3 31.8% 91.4%;--ring:239 84% 67%;--radius:0.625rem}';
  document.head.prepend(s);
}
